import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { EMPTY, finalize, first } from 'rxjs';
import { DeploymentResponse, DeploymentsClient } from '../../../shared';
import { LoadingDefaults } from '../../../shared/models/loading-defaults.model';
import { RplLoadingService } from '../../../shared/services/rpl-loading.service';

export const deploymentResolver: ResolveFn<DeploymentResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const client = inject(DeploymentsClient);
  const loadingService = inject(RplLoadingService);
  const router = inject(Router);

  const id = Number(route.paramMap.get('deploymentId'));

  if (Number.isNaN(id)) {
    void router.navigate(['deployments']);
    return EMPTY;
  }

  let loadingId: string | undefined;
  const timeout = setTimeout(() => {
    loadingId = loadingService.start();
  }, LoadingDefaults.StartIndicatorTimeout);

  return client.getDeploymentById(id).pipe(
    first(),
    finalize(() => {
      clearTimeout(timeout);
      loadingService.end(loadingId);
    }),
  );
};
